import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">黑料不打烊</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              全天24小时不间断追踪娱乐圈最新爆料、明星黑料与劲爆内幕。吃瓜永不缺货！
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/star-scandal" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">明星黑料</Link>
              <Link to="/category/romance-exposure" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">恋情曝光</Link>
              <Link to="/category/variety-insider" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">综艺内幕</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/film-behind" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">影视幕后</Link>
              <Link to="/category/fashion-flop" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">时尚翻车</Link>
              <Link to="/category/legal-trouble" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">法律纠纷</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link>
              <span className="text-sm text-background-400">联系邮箱：tips@heiliaobudayang.com</span>
              <span className="text-sm text-background-400">爆料热线：400-888-6666</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 黑料不打烊 版权所有 | 本网站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="whitespace-nowrap">隐私政策</span>
            <span className="whitespace-nowrap">用户协议</span>
            <span className="whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}